import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { API_URLS } from "./apis/urls";
import Api from "./utils/apiCall";

interface ApplicationModulesState {
    data: any;
    loading: "idle" | "pending" | "fulfilled" | "rejected";
    error: string | null;
    action: "list" | "create" | "update" | "delete" | null;
}

const applicationModulesInitialState: ApplicationModulesState = {
    data: null,
    loading: "idle",
    error: null,
    action: null,
};

// 🔹 GET Application Modules
export const getApplicationModulesAPI: any = createAsyncThunk(
    "application-modules/list",
    async (payload: any, thunkAPI) => {
        try {
            const response = await Api.post(API_URLS.APPLICATION_MODULES.LIST, payload);
            return response.data.data;
        } catch (error: any) {
            return thunkAPI.rejectWithValue(Api.getErrorMessage(error));
        }
    }
);

// 🔹 CREATE Application Module
export const createApplicationModuleAPI: any = createAsyncThunk(
    "application-modules/create",
    async (payload: any, thunkAPI) => {
        try {
            const response = await Api.post(API_URLS.APPLICATION_MODULES.CREATE, payload);
            return response.data;
        } catch (error: any) {
            return thunkAPI.rejectWithValue(Api.getErrorMessage(error));
        }
    }
);

// 🔹 UPDATE Application Module
export const updateApplicationModuleAPI: any = createAsyncThunk(
    "application-modules/update",
    async (payload: any, thunkAPI) => {
        try {
            const response = await Api.post(API_URLS.APPLICATION_MODULES.UPDATE, payload);
            return response.data;
        } catch (error: any) {
            return thunkAPI.rejectWithValue(Api.getErrorMessage(error));
        }
    }
);

// 🔹 DELETE Application Module
export const deleteApplicationModuleAPI: any = createAsyncThunk(
    "application-modules/delete",
    async (payload: any, thunkAPI) => {
        try {
            const response = await Api.post(API_URLS.APPLICATION_MODULES.DELETE, payload);
            return response.data;
        } catch (error: any) {
            return thunkAPI.rejectWithValue(Api.getErrorMessage(error));
        }
    }
);

const applicationModulesSlice = createSlice({
    name: "application-modules",
    initialState: applicationModulesInitialState,
    reducers: {
        resetApplicationModules: (state) => {
            state.data = null;
            state.loading = "idle";
            state.error = null;
            state.action = null;
        },
    },
    extraReducers: (builder) => {
        builder
            // 📥 GET
            .addCase(getApplicationModulesAPI.pending, (state) => {
                state.loading = "pending";
                state.data = null;
                state.error = null;
                state.action = "list";
            })
            .addCase(getApplicationModulesAPI.fulfilled, (state, action) => {
                state.loading = "fulfilled";
                state.data = action.payload;
                state.error = null;
                state.action = "list";
            })
            .addCase(getApplicationModulesAPI.rejected, (state, action) => {
                state.loading = "rejected";
                state.error = action.payload as string;
                state.data = null;
                state.action = "list";
            })

            // ➕ CREATE
            .addCase(createApplicationModuleAPI.pending, (state) => {
                state.loading = "pending";
                state.error = null;
                state.action = "create";
            })
            .addCase(createApplicationModuleAPI.fulfilled, (state, action) => {
                state.loading = "fulfilled";
                state.data = action.payload;
                state.error = null;
                state.action = "create";
            })
            .addCase(createApplicationModuleAPI.rejected, (state, action) => {
                state.loading = "rejected";
                state.error = action.payload as string;
                state.action = "create";
            })

            // 🛠 UPDATE
            .addCase(updateApplicationModuleAPI.pending, (state) => {
                state.loading = "pending";
                state.error = null;
                state.action = "update";
            })
            .addCase(updateApplicationModuleAPI.fulfilled, (state, action) => {
                state.loading = "fulfilled";
                state.data = action.payload;
                state.error = null;
                state.action = "update";
            })
            .addCase(updateApplicationModuleAPI.rejected, (state, action) => {
                state.loading = "rejected";
                state.error = action.payload as string;
                state.action = "update";
            })

            // 🗑 DELETE
            .addCase(deleteApplicationModuleAPI.pending, (state) => {
                state.loading = "pending";
                state.error = null;
                state.action = "delete";
            })
            .addCase(deleteApplicationModuleAPI.fulfilled, (state, action) => {
                state.loading = "fulfilled";
                state.data = action.payload;
                state.error = null;
                state.action = "delete";
            })
            .addCase(deleteApplicationModuleAPI.rejected, (state, action) => {
                state.loading = "rejected";
                state.error = action.payload as string;
                state.action = "delete";
            });
    },
});

export const { resetApplicationModules } = applicationModulesSlice.actions;
export default applicationModulesSlice.reducer;

